export enum HarvestType {
  MANUAL = 'MANUAL',
  COMBINE = 'COMBINE',
  GROUND_HARVESTED = 'GROUND_HARVESTED',
}
